export class FailState {
	readonly error: any;
	readonly loading = false;

	constructor(error: any) {
		this.error = error;
	}
}
